import { useState } from 'react';

interface OtpStepProps {
  phone: string;
  otp: string;
  onOtpChange: (otp: string) => void;
  countdown: number;
  showMockNotice: boolean;
  mockCode: string;
  loading: boolean;
  onVerify: () => void;
  onResend: () => void;
  onBack: () => void;
}

export default function OtpStep({
  phone,
  otp,
  onOtpChange,
  countdown,
  showMockNotice,
  mockCode,
  loading,
  onVerify,
  onResend,
  onBack,
}: OtpStepProps) {
  const [error, setError] = useState('');

  function handleVerify() {
    setError('');
    if (!otp || otp.length !== 6) {
      setError('인증번호 6자리를 입력해주세요.');
      return;
    }
    onVerify();
  }

  return (
    <div className="space-y-6">
      {showMockNotice && (
        <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
          <div className="flex items-start gap-2.5">
            <i className="ri-error-warning-line text-amber-600 mt-0.5" />
            <div className="text-xs text-amber-800 leading-relaxed">
              <p className="font-semibold mb-1">Solapi SMS 설정 안됨 (개발 모드)</p>
              <p>실제 문자는 발송되지 않았습니다. 아래 인증번호를 입력하세요.</p>
              {mockCode && (
                <p className="mt-2 text-sm font-bold text-amber-900">
                  개발용 인증번호: {mockCode}
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      <div>
        <label className="block text-xs font-semibold text-gray-600 mb-2">
          인증번호 6자리
        </label>
        <input
          type="text"
          inputMode="numeric"
          value={otp}
          onChange={(e) => onOtpChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
          placeholder="000000"
          maxLength={6}
          className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm outline-none focus:border-[#2E7D6B] bg-white text-center text-lg tracking-[0.5em] font-bold"
          autoComplete="off"
        />
      </div>

      {/* 액션 버튼 */}
      <div className="flex gap-3">
        <button
          onClick={onBack}
          className="flex-1 py-3.5 rounded-xl text-sm font-bold text-gray-600 bg-gray-100 whitespace-nowrap cursor-pointer hover:bg-gray-200 transition-colors"
        >
          이전
        </button>
        <button
          onClick={handleVerify}
          disabled={loading || otp.length !== 6}
          className="flex-1 py-3.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity disabled:opacity-50"
          style={{ backgroundColor: '#2E7D6B' }}
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <i className="ri-loader-4-line animate-spin" />
              확인 중...
            </span>
          ) : (
            '인증하고 가입하기'
          )}
        </button>
      </div>

      <div className="text-center">
        {countdown > 0 ? (
          <p className="text-xs text-gray-400">
            {Math.floor(countdown / 60)}:{String(countdown % 60).padStart(2, '0')} 후에 다시 받을 수 있어요
          </p>
        ) : (
          <button
            onClick={onResend}
            disabled={loading}
            className="text-xs text-[#2E7D6B] font-medium cursor-pointer"
          >
            인증번호 다시 받기
          </button>
        )}
      </div>

      {error && (
        <div className="p-3 rounded-xl bg-red-50 text-xs text-red-500 text-center">{error}</div>
      )}
    </div>
  );
}